const encounterStatusEnum = Object.freeze({
  CREATED: {
    value: 'CREATED',
    previousSession: false,
  },
  RECC: {
    value: 'RECC',
    previousSession: true,
  },
  REVIEW: {
    value: 'REVIEW',
    previousSession: false,
  },
  DRAFT_CREATED: {
    value: 'DRAFT_CREATED',
    previousSession: true,
    draftSession: true,
  },
  DRAFT_RECC: {
    value: 'DRAFT_RECC',
    previousSession: true,
    draftSession: true,
  },
  DRAFT_REVIEW: {
    value: 'DRAFT_REVIEW',
    previousSession: true,
    draftSession: true,
  },
  FINISHED: {
    value: 'FINISHED',
    previousSession: true,
  },
  S2K_PENDED: {
    value: 'S2K_PENDED',
    previousSession: true,
  },
})

export default encounterStatusEnum